import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientService } from 'src/app/service/client.service';
import { ComodatoService } from 'src/app/service/comodato.service';
import { ProductService } from 'src/app/service/product.service';
import { Comodato } from './comodato';

@Component({
  selector: 'app-comodato-form',
  templateUrl: './comodato-form.component.html',
  styleUrls: ['./comodato-shared.scss'],
})
export class ComodatoFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;

  constructor(
    private comodatoService: ComodatoService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private productService: ProductService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.prefillClienteFromLocalStorage();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarFormulario(codCliente?: number) {
    this.formulario = this.formBuilder.group({
      id: [null, Validators.nullValidator],
      codCliente: [codCliente ?? null, [Validators.minLength(1), Validators.maxLength(250)]],
      cliente: [null, Validators.nullValidator],
      codProduto: [null, Validators.nullValidator],
      produto: [null, Validators.nullValidator],
      quantidade: [null, Validators.nullValidator],
      dtEmprestimo: [null, Validators.nullValidator],
      observacao: [null, Validators.nullValidator],
      dtPrevisaoDevolucao: [null],
      dtDevolucao: [null],
      numeroQuantidade: [null],
    });
  }

  prefillClienteFromLocalStorage() {
    const clienteComodato = localStorage.getItem('clienteComodato');
    if (clienteComodato !== null) {
      const codCliente = parseInt(clienteComodato.trim(), 10);
      localStorage.removeItem('clienteComodato');
      this.formulario.patchValue({ codCliente });
      this.buscarClient();
    }
  }

  carregar(id: number) {
    this.carregando = true;
    this.comodatoService.findClientById(id).subscribe(response => {
      this.formulario.patchValue({
        id,
        codCliente: response.clienteId,
        cliente: response.cliente,
        codProduto: response.produtoId,
        produto: response.produto,
        quantidade: response.quantidade,
        dtEmprestimo: response.dtEmprestimo,
        dtPrevisaoDevolucao: response.dtPrevisaoDevolucao,
        dtDevolucao: response.dtDevolucao,
        observacao: response.observacao,
        numeroQuantidade: response.numeroQuantidade,
      });
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Comodato não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    const formValues = this.formulario.value;
    const comodato = new Comodato(
      formValues.id,
      formValues.codCliente,
      formValues.cliente,
      formValues.codProduto,
      formValues.produto,
      formValues.quantidade,
      formValues.dtEmprestimo,
      formValues.dtPrevisaoDevolucao,
      formValues.dtDevolucao,
      formValues.observacao,
      formValues.numeroQuantidade,
    );

    const request = formValues.id
      ? this.comodatoService.update(comodato)
      : this.comodatoService.save(comodato);

    request.subscribe(() => {
      this.snackBar.open(
        formValues.id ? 'Comodato alterado com sucesso!' : 'Comodato salvo com sucesso!',
        'Sucesso',
        { duration: 2000 },
      );
      this.voltarConsulta();
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', { duration: 2000 });
    });
  }

  buscarClient() {
    const codCliente = this.formulario.get('codCliente')?.value;
    if (!codCliente) {
      return;
    }
    this.clientService.findClientById(codCliente).subscribe(response => {
      this.formulario.patchValue({ cliente: response.razaoSocial });
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', { duration: 3000 });
    });
  }

  buscarProduto() {
    const codProduto = this.formulario.get('codProduto')?.value;
    if (!codProduto) {
      return;
    }
    this.productService.findProductByIdActive(codProduto).subscribe(response => {
      this.formulario.patchValue({ produto: response.name });
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', { duration: 3000 });
    });
  }

  limpar() {
    this.router.navigate(['/comodato/form']);
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/comodato/consulta']);
  }
}
